import { render, staticRenderFns } from "./RunnitBoardTile.vue?vue&type=template&id=2b53ad34&scoped=true"
import script from "./RunnitBoardTile.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardTile.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBoardTile.vue?vue&type=style&index=0&id=2b53ad34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b53ad34",
  null
  
)

export default component.exports